import styled from "styled-components";
import shades from "../../../styles/shadesPalette";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  padding-left: 71px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  @media (max-width: 1400px) {
    padding-left: 35px;
  }
`;

export const TableContainer = styled.div`
  width: 1600px;
  height: 600px;
  background: transparent;
  overflow: hidden;
  box-shadow: ${shades.shadow3};
  @media (max-width: 1400px) {
    width: 1087px;
    height: 354px;
  }
`;

export const CaptchaContainer = styled.div`
  display: flex;
  width: 350px;
  height: 84px;
  margin-top: 61px;
  margin-bottom: 57px;
  background: red;
`;
